// extracted by mini-css-extract-plugin
module.exports = {"root":"TextBlock_root__2ULP8"};